import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { SettingsAPI } from "@/lib/api";

const SettingsContext = createContext(null);

const DEFAULTS = {
  show_recent_medals: true,
  show_sport_tabs: true,
  show_features_grid: true,
  show_stats_counter: true,
  show_player_videos: true,
  show_tournament_videos: true,
  enabled_sports: [
    "football", "tennis", "basket", "voile", "ski", "hockey",
    "rugby", "athletisme", "cyclisme", "natation", "golf",
  ],
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const data = await SettingsAPI.get();
      setSettings({ ...DEFAULTS, ...data });
    } catch {
      // keep defaults on error
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, loaded, refresh, setSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
